import React from 'react'

const UsersIcon = ({ color }) => {
  return (
    <svg
      width="23"
      height="25"
      viewBox="0 0 23 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17 5.50479C17 6.98998 16.3974 8.38415 15.2975 9.42857C15.0775 9.63458 14.8431 9.82622 14.5944 9.99869C13.6571 10.6407 12.538 11 11.4189 11C10.5724 11 9.75462 10.7988 8.99421 10.4107C8.779 10.3005 8.56857 10.1712 8.37249 10.0322C6.98559 9.05967 6.08171 7.44512 6.00519 5.74913C5.91911 3.76568 6.90907 1.87805 8.59249 0.824041C9.45811 0.287456 10.4624 0 11.505 0C12.4615 0 13.394 0.244338 14.2071 0.709059C15.9287 1.68641 17 3.52134 17 5.50479Z"
        fill={color}
      />
      <path
        d="M23 18.0624V21.6451C23 22.2937 22.605 22.8754 22.015 23.0967C15.235 25.6344 7.765 25.6344 0.985 23.0967C0.395 22.8754 0 22.2937 0 21.6451V18.0624C0 16.1218 0.945 14.3407 2.535 13.2958C4.165 12.2148 5.945 11.4478 7.835 11.0154C8.025 11.1441 8.22 11.2625 8.425 11.3706C9.365 11.8699 10.37 12.1222 11.415 12.1222C12.28 12.1222 13.145 11.942 13.955 11.6074C14.35 11.4427 14.73 11.2368 15.095 11C17.01 11.4324 18.815 12.2045 20.465 13.2958C22.055 14.3407 23 16.1218 23 18.0624Z"
        fill={color}
      />
    </svg>
  )
}

export default UsersIcon
